import { Action } from '@ngrx/store';
import { Address, PropertiesState } from './properties.state';
import { ArcGisToken, DnvLatLng } from 'dnv-lib';

export const PropertiesActionType = {
  SetPropertyInfo: '[Properties] SetPropertyInfo',
  GetPropertyByXY: '[Properties] GetPropertyByXY',
  GetPropertyInfo: '[Properties] GetPropertyInfo',
  GetPropertyByAddress: '[Properties] GetPropertyByAddress',
  GetPropertyByFolio: '[Properties] GetPropertyByFolio',
  GetPropertyByPID: '[Properties] GetPropertyByPID',
  SetSelectedProperty: '[Properties] SetSelectedProperty',
  SetGeoJsonProperty: '[Properties] SetGeoJsonProperty',
  GetAirSpaceDbLink: '[Properties] GetAirSpaceDbLink',
  SetPropertiesDbLinks: '[Properties] SetPropertiesDbLinks',
  GetPropertyBoundingBox: '[Properties] GetPropertyBoundingBox',
  SetPropertyBoundingBox: '[Properties] SetPropertyBoundingBox',
  PrintSvcConn: '[Properties] PrintSvcConn',
  GetPrintSvcConn: '[Properties] GetPrintSvcConn',
  SetPrintSvcConn: '[Properties] SetPrintSvcConn',
  GetAddressByDbLink: '[Properties] GetAddressByDbLink',
  SetAddressByDbLink: '[Properties] SetAddressByDbLink',
  GetServiceConnectionsByLatLong: '[Properties] GetServiceConnectionsByLatLong',
  ResetGeoJsonProperty: '[Properties] ResetGeoJsonProperty',
  GetEnerGovInfo: '[Properties] GetEnerGovInfo',
  SetEnerGovInfo: '[Properties] SetEnerGovInfo',
};

export class GetPropertyByXY implements Action {
  public type: string = PropertiesActionType.GetPropertyByXY;

  constructor(public payload: DnvLatLng) { }
}

export class GetPropertyInfo implements Action {
  public type: string = PropertiesActionType.GetPropertyInfo;

  constructor(public payload: string) { }
}

export class SetPropertyInfo implements Action {
  public type: string = PropertiesActionType.SetPropertyInfo;

  constructor(public payload: any) { }
}

export class GetPropertyByAddress implements Action {
  public type: string = PropertiesActionType.GetPropertyByAddress;

  constructor(public payload: any) { }
}

export class GetPropertyByFolio implements Action {
  public type: string = PropertiesActionType.GetPropertyByFolio;

  constructor(public payload: string) { }
}

export class GetPropertyByPID implements Action {
  public type: string = PropertiesActionType.GetPropertyByPID;

  constructor(public payload: string) { }
}

export class SetSelectedProperty implements Action {
  public type: string = PropertiesActionType.SetSelectedProperty;

  constructor(public payload: string) { }
}

export class SetGeoJsonProperty implements Action {
  public type: string = PropertiesActionType.SetGeoJsonProperty;

  constructor(public payload: any = null) { }
}

export class GetAirSpaceDbLink implements Action {
  public type: string = PropertiesActionType.GetAirSpaceDbLink;

  constructor(public payload: string) { }
}

export class SetPropertiesDbLinks implements Action {
  public type: string = PropertiesActionType.SetPropertiesDbLinks;

  constructor(public payload: any) { }
}

export class GetPropertyBoundingBox implements Action {
  public type: string = PropertiesActionType.GetPropertyBoundingBox;

  constructor(public payload: any) { }
}

export class SetPropertyBoundingBox implements Action {
  public type: string = PropertiesActionType.SetPropertyBoundingBox;

  constructor(public payload: any) { }
}

export class PrintSvcConn implements Action {
  public type: string = PropertiesActionType.PrintSvcConn;

  constructor(public payload: { dblink: string, opacity: number, token: string }) { }
}

export class GetPrintSvcConn implements Action {
  public type: string = PropertiesActionType.GetPrintSvcConn;

  constructor(public payload: string) { }
}

export class SetPrintSvcConn implements Action {
  public type: string = PropertiesActionType.SetPrintSvcConn;

  constructor(public payload: any) { }
}

export class GetAddressByDbLink implements Action {
  public type: string = PropertiesActionType.GetAddressByDbLink;

  constructor(public payload: any) { }
}

export class SetAddressByDbLink implements Action {
  public type: string = PropertiesActionType.SetAddressByDbLink;

  constructor(public payload: any) { }
}

export class GetServiceConnectionsByLatLong implements Action {
  public type: string = PropertiesActionType.GetServiceConnectionsByLatLong;

  constructor(public payload: DnvLatLng) { }
}

export class ResetGeoJsonProperty implements Action {
  public type: string = PropertiesActionType.ResetGeoJsonProperty;

  constructor(public payload: any = null) { }
}

export class GetEnerGovInfo implements Action {
  public type: string = PropertiesActionType.GetEnerGovInfo;

  constructor(public payload: string) { }
}

export class SetEnerGovInfo implements Action {
  public type: string = PropertiesActionType.SetEnerGovInfo;

  constructor(public payload: any = null) { }
}

export type PropertiesAction =
  SetPropertyInfo |
  GetPropertyInfo |
  GetPropertyByXY |
  GetPropertyByAddress |
  GetPropertyByFolio |
  GetPropertyByPID |
  SetSelectedProperty |
  GetAirSpaceDbLink |
  SetPropertiesDbLinks |
  GetPropertyBoundingBox |
  SetPropertyBoundingBox |
  PrintSvcConn |
  GetPrintSvcConn |
  SetPrintSvcConn |
  GetAddressByDbLink |
  SetAddressByDbLink |
  GetServiceConnectionsByLatLong |
  SetGeoJsonProperty |
  ResetGeoJsonProperty |
  GetEnerGovInfo |
  SetEnerGovInfo
  ;
